import { useCallback, useEffect, useState } from "react";
import { fetchServiceExplorer, type AdminConsoleFailure, type ServiceExplorer } from "@/lib/admin-console-api";

export type ServiceExplorerState =
  | { kind: "loading" }
  | { kind: "ready"; explorer: ServiceExplorer }
  | { kind: "failed"; failure: AdminConsoleFailure };

/** One read of GET /admin/api/service-explorer, shared by Services and Configuration (ALL-5776). */
export function useServiceExplorer(): { state: ServiceExplorerState; reload: () => void } {
  const [state, setState] = useState<ServiceExplorerState>({ kind: "loading" });
  const [generation, setGeneration] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState({ kind: "loading" });
    void fetchServiceExplorer().then((result) => {
      if (cancelled) return;
      setState(result.ok ? { kind: "ready", explorer: result.data } : { kind: "failed", failure: result });
    });
    return () => {
      cancelled = true;
    };
  }, [generation]);

  const reload = useCallback(() => setGeneration((value) => value + 1), []);
  return { state, reload };
}

export function formatCheckedAt(iso: string | undefined): string | undefined {
  if (!iso) return undefined;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? undefined : d.toLocaleString();
}
